import { request } from '@tencent/ppd-base-libs';

export interface AnnounceItemRaw {
  /** 生效时间 */
  startTime: string;
  /** 失效时间 */
  endTime: string;
  /** 滚播文案（简体） */
  cnText: string;
  /** 滚播文案（繁体） */
  hkText: string;
  /** 滚播文案（英文） */
  enText: string;
  /** icon url */
  icon: string;
  /** 上报扩展字段值 */
  biTag: string;
}
/**
 * 根据url请求轮播数据
 */
export async function qryLoopData(dataUrl: string): Promise<AnnounceItemRaw[]> {
  const announceData = await request.loadVtools(dataUrl);

  return announceData;
}
